module.exports = __webpack_public_path__ + "img/12_45.ee3afafd.png";